import axios from "../../utils/axios";

// 售后工单管理
export function getList(query) {
    return axios({
        url: "otherorder/getList",
        method: "get",
        params: query
    });
}

// 售后工单管理详情
export function getOrderWorkInfo(query) {
    return axios({
        url: "orderWorkManage/getInfo",
        method: "get",
        params: query
    });
}

// 生成存根url
export function genStub(query) {
    return axios({
        url: "otherorder/genStub",
        method: "get",
        params: query
    });
}

// 售后工单处理
export function handle(query) {
    return axios({
        url: "orderWorkManage/update",
        method: "get",
        params: query
    });
}


